// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/RetailItems/RetailItem/Type/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_EmbeddableCoreMessageListener_PaymentsCreateInvoice_RetailItems_RetailItem_Type($location_id: uuid!) {
  vaxiom_retail_items(
    where: {
      organization: { _id: { _eq: $location_id } }
      available: { _eq: true }
    }
    order_by: { name: asc_nulls_last }
  ) {
    id
    text: name
    name
    price
  }
}

`